var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSeats2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.5a7.5 7.5 0 010 15H9a7.5 7.5 0 010-15h6zm-3.066 1.94c-.757 0-1.404.153-1.94.46a3.107 3.107 0 00-1.231 1.231 3.455 3.455 0 00-.425 1.7h1.765c0-.386.068-.728.205-1.026.137-.303.34-.54.608-.71.269-.171.6-.257.996-.257.342 0 .632.076.872.227.239.147.42.35.542.608.127.254.19.55.19.887 0 .239-.046.485-.139.74-.088.248-.242.53-.462.842-.22.312-.52.683-.9 1.113L8.543 16.04v1.209h7.148v-1.406H10.77l2.307-2.542c.322-.332.617-.659.886-.981.268-.327.5-.652.696-.974.2-.327.354-.655.461-.982.107-.327.161-.656.161-.989 0-.6-.132-1.12-.395-1.56a2.567 2.567 0 00-1.135-1.018c-.499-.239-1.104-.359-1.817-.359z",
    fill: "currentColor"
  })));
}
SvgPokerSeats2.displayName = 'PokerSeats2';
export default SvgPokerSeats2;